import React from 'react';

import AccountList from 'components/Tvendo/Bank/Operations/AccountList/List.js';

export default function () {
  return <AccountList />;
}
